module.exports = "/_next/static/videos/snowboarding-1-0504fe639d04f3bf17ece3c6262909b6.webm";